import { Fragment, type ReactNode } from 'react';

/**
 * The small Markdown subset Master Kala is told to use: paragraphs, bullet and
 * numbered lists, and bold. Built from React elements, never HTML, so model
 * output cannot inject markup.
 */
function inline(text: string): ReactNode[] {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.length > 4 && part.startsWith('**') && part.endsWith('**') ? (
      <strong key={i} className="font-semibold text-ink">
        {part.slice(2, -2)}
      </strong>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  );
}

const BULLET = /^\s*[-*•]\s+/;
const NUMBERED = /^\s*\d+[.)]\s+/;

export function RichText({ text }: { text: string }) {
  const blocks = text
    .replace(/\r/g, '')
    .trim()
    .split(/\n{2,}/);
  return (
    <div className="space-y-3">
      {blocks.map((block, i) => {
        const lines = block.split('\n').filter((l) => l.trim());
        if (lines.length && lines.every((l) => BULLET.test(l))) {
          return (
            <ul key={i} className="list-disc space-y-1.5 pl-5 marker:text-sage">
              {lines.map((l, j) => (
                <li key={j}>{inline(l.replace(BULLET, ''))}</li>
              ))}
            </ul>
          );
        }
        if (lines.length && lines.every((l) => NUMBERED.test(l))) {
          return (
            <ol key={i} className="list-decimal space-y-1.5 pl-5 marker:text-sage">
              {lines.map((l, j) => (
                <li key={j}>{inline(l.replace(NUMBERED, ''))}</li>
              ))}
            </ol>
          );
        }
        return (
          <p key={i}>
            {lines.map((l, j) => (
              <Fragment key={j}>
                {j > 0 && <br />}
                {inline(l.replace(/^#{1,6}\s+/, ''))}
              </Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
